import React, { useEffect, useRef } from "react";

const APP_SCHEME = "bbcapp";
const APP_URL = "bbcapp://login";
const ANDROID_PACKAGE = "com.bearbrick.connect";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.bearbrick.connect";
const APP_STORE_URL = "https://apps.apple.com/app/id6777928150";

const AppDownBridgeUi = () => {
    const storeOpenedRef = useRef(false);
    const userAgent = navigator.userAgent;
    const isAndroid = /Android/i.test(userAgent);
    const isIos = /iPhone|iPad|iPod/i.test(userAgent)
        || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const isMac = !isIos && !isAndroid && /Mac/i.test(navigator.platform);
    const isChrome = isAndroid && /Chrome/i.test(userAgent)
        && !/SamsungBrowser|EdgA|OPR|Whale|Firefox/i.test(userAgent);
    const isInAppBrowser = /KAKAOTALK|NAVER|Instagram|FBAN|FBAV|Line\//i.test(userAgent);

    const openStore = () => {
        if(storeOpenedRef.current) return;
        if(document.visibilityState === "hidden") {
            const retry = () => {
                if(document.visibilityState === "hidden") return;
                document.removeEventListener("visibilitychange", retry);
                openStore();
            };
            document.addEventListener("visibilitychange", retry);
            return;
        }

        const storeUrl = isIos
            ? APP_STORE_URL.replace(/^https:/, "itms-apps:")
            : isMac
                ? APP_STORE_URL
                : isAndroid
                    ? PLAY_STORE_URL
                    : "";

        if(!storeUrl) return;
        storeOpenedRef.current = true;

        if(/KAKAOTALK/i.test(userAgent)) {
            window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(storeUrl)}`;
            return;
        }

        window.location.href = storeUrl;
    };

    const tryCustomScheme = () => {
        const launcherFrame = document.createElement("iframe");
        launcherFrame.setAttribute("aria-hidden", "true");
        launcherFrame.style.cssText = "display:none;width:0;height:0;border:0";
        launcherFrame.src = APP_URL;
        document.body.appendChild(launcherFrame);
    };

    const openAndroid = () => {
        if(isChrome) {
            window.location.href = PLAY_STORE_URL;
            return;
        }

        const fallbackUrl = encodeURIComponent(PLAY_STORE_URL);
        window.location.href = `intent://login#Intent;scheme=${APP_SCHEME};package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallbackUrl};end`;
        window.setTimeout(() => {
            if(storeOpenedRef.current || document.visibilityState === "hidden") return;
            storeOpenedRef.current = true;
            window.location.href = PLAY_STORE_URL;
        }, 1200);
    };

    const openApp = () => {
        if(isMac || isInAppBrowser) {
            openStore();
            return;
        }

        if(isAndroid) {
            openAndroid();
            return;
        }

        window.setTimeout(openStore, 700);
        if(isIos) {
            tryCustomScheme();
            return;
        }

        window.location.href = APP_URL;
    };

    useEffect(() => {
        if(isMac) {
            openStore();
        } else if(isAndroid) {
            openAndroid();
        } else if(isIos) {
            window.setTimeout(openApp, 400);
        }
        // 제공된 web-login 페이지와 동일한 최초 실행 흐름을 유지합니다.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <p>앱의 로그인 화면으로 이동합니다.</p>
            <button type="button" onClick={openApp}>앱에서 열기</button>
            {isAndroid && <a href={PLAY_STORE_URL}>Google Play</a>}
            {(isIos || isMac) && <a href={APP_STORE_URL}>App Store</a>}
        </div>
    );
};

export default AppDownBridgeUi;